/**
 * GLDN Free Ring Sizer — 1 per order (gldn49 / #272)
 *
 * Enforces a maximum of one `free-ring-sizer` line on the customer-facing
 * paths WITHOUT adding a window.fetch monkey-patch — deliberately avoids
 * racing gldn-cart-unique / gldn-cart-orphan-cleanup on /cart/change.js. This
 * file is read-only + UI-only (it never mutates the cart):
 *
 *   PDP   — the server-side Liquid gate in blocks/buy-buttons.liquid disables
 *           the add-to-cart button + shows the notice when the sizer is
 *           already in the cart at page load. This file closes the
 *           same-session gap: after the sizer is added from its own PDP (no
 *           reload), re-disable the button + reveal the notice so a second
 *           add is blocked.
 *   Cart  — the sizer line renders with max="1" (cart-products.liquid →
 *           quantity-selector), so Horizon's quantity component natively
 *           disables "+" and clamps typed values back to 1. This file only
 *           surfaces the "1 per order" message (reusing Horizon's native
 *           per-line error UI) when the customer attempts to exceed 1.
 *
 * Everything is scoped to handle 'free-ring-sizer'; all other products are
 * untouched (AC-3). Wrapped in try/catch so a failure here can never break
 * the cart or checkout.
 */
(function () {
  'use strict';

  var HANDLE = 'free-ring-sizer';
  var MESSAGE = 'Only 1 free ring sizer is allowed per order.';
  var ROW = '[data-gldn-ring-sizer="true"]';

  /* ───────────── cart page / drawer: surface the message ───────────── */

  // Reuse Horizon's native per-line error elements (cartItemError-{N} and its
  // container), the same ones the cart component uses for quantity errors.
  function showCartLineMessage(row) {
    try {
      var input = row.querySelector('input[data-cart-line]');
      var line = input && input.getAttribute('data-cart-line');
      if (!line) return;
      var text = document.querySelector('[ref="cartItemError-' + line + '"]');
      var container = document.querySelector('[ref="cartItemErrorContainer-' + line + '"]');
      if (text) text.textContent = MESSAGE;
      if (container) container.classList.remove('hidden');
    } catch (e) {}
  }

  // Typed / arrow-key attempts to exceed 1. The quantity component clamps the
  // value back to 1 on blur (max="1"); we only show the message.
  document.addEventListener('input', function (e) {
    try {
      var input = e.target;
      if (!input || input.name !== 'updates[]' || !input.closest) return;
      var row = input.closest(ROW);
      if (row && (parseInt(input.value, 10) || 0) > 1) showCartLineMessage(row);
    } catch (e) {}
  });

  // The ring sizer is capped at 1, so it has no legitimate quantity change.
  // The Horizon quantity component still fires a 'quantity-selector:update' on
  // blur even when the value was clamped back to 1 — which makes the cart
  // component POST a no-op /cart/change.js and re-morph the line, wiping our
  // message. Intercept that event in the CAPTURE phase (runs before the cart
  // component's bubble-phase listener) for ring-sizer lines only: stop it,
  // then show the message so it persists (no re-render). Removal uses a
  // different handler (onLineItemRemove), so it is unaffected.
  document.addEventListener('quantity-selector:update', function (e) {
    try {
      var el = e.target;
      if (!el || !el.closest) return;
      var row = el.closest(ROW);
      if (!row) return;
      e.stopImmediatePropagation();
      showCartLineMessage(row);
    } catch (e) {}
  }, true);

  // Taps on the (disabled) "+" of a ring-sizer line. The injected CSS sets
  // pointer-events:none on the disabled plus so the click lands on the row.
  document.addEventListener('click', function (e) {
    try {
      if (!e.target.closest) return;
      var row = e.target.closest(ROW);
      if (!row) return;
      var sel = e.target.closest('.quantity-selector');
      if (!sel) return;
      var plus = sel.querySelector('button[name="plus"]');
      if (plus && plus.disabled) showCartLineMessage(row);
    } catch (e) {}
  });

  function injectStyles() {
    if (document.getElementById('gldn-ring-sizer-styles')) return;
    var s = document.createElement('style');
    s.id = 'gldn-ring-sizer-styles';
    s.textContent = ROW + ' .quantity-selector button[name="plus"]:disabled{pointer-events:none;}';
    (document.head || document.documentElement).appendChild(s);
  }
  injectStyles();

  /* ───────────── PDP: close the same-session re-add gap ───────────── */

  function ringSizerInCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (it) { return it.handle === HANDLE; });
      })
      .catch(function () { return false; });
  }

  function blockPdpAtc() {
    try {
      var form = document.querySelector('[data-gldn-ring-sizer-pdp]');
      if (!form) return;
      form.querySelectorAll('button[name="add"]').forEach(function (b) { b.disabled = true; });
      var msg = form.querySelector('[data-gldn-ring-sizer-msg]');
      if (msg) msg.classList.remove('hidden');
      // also hide the accelerated-checkout (express) buttons so they can't
      // bypass the gate from the sizer's own PDP
      var express = form.querySelector('.accelerated-checkout-block');
      if (express) express.setAttribute('hidden', '');
    } catch (e) {}
  }

  function maybeBlockPdp() {
    // Only relevant on the ring sizer's own PDP.
    if (!document.querySelector('[data-gldn-ring-sizer-pdp]')) return;
    ringSizerInCart().then(function (present) {
      if (!present) return;
      // Re-apply after Horizon's own post-add button reset (which runs
      // synchronously in the add's .then, i.e. during cart:update dispatch).
      requestAnimationFrame(blockPdpAtc);
      setTimeout(blockPdpAtc, 80);
    });
  }

  document.addEventListener('cart:update', maybeBlockPdp);
})();
